export default __webpack_public_path__ + "static/media/sportsbra-medium-front.cee6f83f.jpg";